.container {
    composes: secondary-sidebar from '../../../client_modules/shells/react/components/navigation/secondary-sidebar/secondary-sidebar.module.css';
    width: 200px;
}

.header-section {
    margin-bottom: 16px;
}

.sidebar-sections {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.search-bar-container {
    margin-bottom: 16px;
}
